import React from "react";

// eslint-disable-next-line import/prefer-default-export
export const InputFocusRefContext =
  React.createContext<React.RefObject<HTMLInputElement> | null>(null);
